import { render } from "./WebcamSourceSelectionMenu.vue?vue&type=template&id=51f521d0"
import script from "./WebcamSourceSelectionMenu.vue?vue&type=script&lang=ts"
export * from "./WebcamSourceSelectionMenu.vue?vue&type=script&lang=ts"
script.render = render

export default script